module.exports = __webpack_public_path__ + "img/RW.2a59b860.svg";